import AsyncButton from '@wojtekmaj/react-async-button';
import T, { useTranslation } from '@wojtekmaj/react-t';

import { toast } from '@rewardopl/react-toast';

import Button from '@rewardopl/react-ui/button';

import { post } from '@rewardopl/utils/network';

import type { Reward, Transaction } from '@rewardopl/types';
import type { SetStateAction } from 'jotai';

const pendingConfig = {
  disabled: true,
};

type RedeemButtonProps = {
  disabled?: boolean;
  onSuccess: (nextTransaction: Transaction) => void;
  reward: Reward;
  setTransactions: (nextValueOrSetter: SetStateAction<Transaction[]>) => void;
};

export default function RedeemButton({
  disabled,
  onSuccess,
  reward,
  setTransactions,
}: RedeemButtonProps) {
  const rewardErrorString = useTranslation('Failed to buy the reward');

  const { _id: rewardId, card_id: cardId } = reward;

  async function onClick() {
    try {
      const nextTransaction = (await post(
        `/api/cards/${cardId}/rewards/${rewardId}/buy`,
      )) as Transaction;

      setTransactions((prevTransactions) => {
        function isSameTransaction(prevTransaction: Transaction) {
          return prevTransaction._id === nextTransaction._id;
        }

        function replaceTransaction(prevTransaction: Transaction) {
          return isSameTransaction(prevTransaction) ? nextTransaction : prevTransaction;
        }

        return prevTransactions.find(isSameTransaction)
          ? prevTransactions.map(replaceTransaction)
          : [nextTransaction, ...prevTransactions];
      });

      onSuccess(nextTransaction);
    } catch {
      toast.error(rewardErrorString);
    }
  }

  return (
    <AsyncButton
      as={Button}
      className="primary"
      disabled={disabled}
      onClick={onClick}
      pendingConfig={pendingConfig}
      type="button"
    >
      <T>Redeem</T>
    </AsyncButton>
  );
}
